import { Notify, Platform, copyToClipboard as quasarCopyFn } from 'quasar'
import { i18n } from '@/i18n'

const t = i18n.global.t

export default (copiedItem) => {
  const onCopy = () => {
    Notify.create({
      message: t('monolith.global.copy.success'),
      position: Platform.is.mobile ? 'top' : 'bottom',
      color: 'positive',
    })
  }

  const onCopyError = () => {
    Notify.create({
      message: t('monolith.global.copy.error'),
      position: Platform.is.mobile ? 'top' : 'bottom',
      color: 'negative',
    })
  }

  if (copiedItem) {
    quasarCopyFn(copiedItem).then(onCopy).catch(onCopyError)
  }
}
